type FbqFunction = (...args: unknown[]) => void

/**
 * Dispara un evento del Meta Pixel si el píxel ya está cargado en la página.
 * No inicializa nada: eso lo hace useMetaPixel en la ruta correspondiente.
 */
export function trackMetaEvent(event: string, params?: Record<string, unknown>) {
  const w = window as Window & typeof globalThis & { fbq?: FbqFunction }
  if (typeof w.fbq !== 'function') return

  if (params) {
    w.fbq('track', event, params)
  } else {
    w.fbq('track', event)
  }
}

/** Convierte un precio con formato ("$19.99") en número para los parámetros del evento. */
export function parsePriceValue(price: string): number {
  const parsed = Number.parseFloat(price.replace(/[^0-9.]/g, ''))
  return Number.isFinite(parsed) ? parsed : 0
}
